import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import car1 from "../../assets/aboutimages/4.jpeg";
import car2 from "../../assets/aboutimages/5.jpg";
import car3 from "../../assets/aboutimages/6.jpg";
import car4 from "../../assets/aboutimages/7.jpeg";
import car5 from "../../assets/aboutimages/8.jpg";
import car6 from "../../assets/aboutimages/9.jpg";

const AboutUs = () => {
  const images = [car1, car2, car3, car4, car5, car6];

  // ✅ Only gate on the FIRST image
  const [isReady, setIsReady] = useState(false);

  // Pre-decode the first image so the loader goes away even if the <img> onLoad doesn't fire yet
  useEffect(() => {
    const firstSrc = images[0];
    if (!firstSrc) return;

    const img = new Image();
    img.src = firstSrc;

    // decode() is more reliable than onload for cached images
    if (img.decode) {
      img
        .decode()
        .then(() => setIsReady(true))
        .catch(() => setIsReady(true)); // don't block UI on decode errors
    } else {
      img.onload = () => setIsReady(true);
      img.onerror = () => setIsReady(true);
    }
  }, [images]);

  // Fallback: if first <img> loads before decode finishes, unlock immediately
  const handleFirstImgLoad = () => setIsReady(true);

  return (
    <>
      <div className="pt-20 lg:pt-28" id="about" />
      <section className="w-full bg-black text-white">
        <div className="flex flex-col lg:flex-row">
          <div className="w-full lg:w-1/2 relative">
            {!isReady && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/80 z-10">
                <svg
                  className="animate-spin h-10 w-10 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
              </div>
            )}

            <Carousel
              showThumbs={false}
              infiniteLoop
              autoPlay={isReady}     
              interval={4000}
              showStatus={false}
              className="lg:rounded-tr-[20px] lg:rounded-br-[20px] h-[700px] mx-3 overflow-hidden"
            >
              {images.map((src, index) => (
                <div key={index}>
                  <img
                    src={src}
                    alt={`Car Image ${index + 1}`}
                    // First image unlocks the loader immediately on load
                    onLoad={index === 0 ? handleFirstImgLoad : undefined}
                    loading={index === 0 ? "eager" : "lazy"}
                    decoding="async"
                    className="w-full h-[700px] object-contain sm:object-cover"
                  />
                </div>
              ))}
            </Carousel>
          </div>

          {/* Right side - Text Content (unchanged) */}
         <div className="w-full lg:w-1/2 bg-black text-white p-8 lg:p-12 flex flex-col justify-center rounded-tl-[20px] rounded-bl-[20px]">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 leading-relaxed">
              Wir sind Bustos Automobile
            </h2>
            <p className="mb-4 leading-relaxed">
              Wir von Bustos Automobile GmbH sind Ihr zuverlässiger Partner im Automobilhandel – seit unserer Gründung im März 2021 in Laupen (Kanton Zürich) stehen wir für Kompetenz, Vielfalt und individuellen Service.
            </p>
            <p className="mb-4 leading-relaxed">
              Unser erfahrenes Team unter der Leitung von Antonio Bustos Lopez bietet Ihnen ein sorgfältig ausgewähltes Sortiment – von robusten Nutzfahrzeugen bis zu stilvollen Limousinen – alles bestens gepflegt und bei Bedarf mit Leasingoptionen oder Eintauschmöglichkeiten
            </p>
            <p className="mb-4 leading-relaxed">
              Wir sind stolz auf unsere hohe Kundenzufriedenheit (4,9★ bei über 100 Bewertungen) und setzen auf persönliche Beratung, transparente Abläufe und faire Konditionen – ganz nach dem Motto: Ihr Wunsch. Unser Anspruch.
            </p>
            <p className="mb-4 leading-relaxed">
              Als Ihr kompetenter Partner rund um den Kauf und Verkauf von Fahrzeugen bieten wir Ihnen in Zusammenarbeit mit unserem Partner abpay.net auch die Möglichkeit, mit Bitcoin, der weltweit führenden Kryptowährung oder der digitalen Währung USDC, zu bezahlen. Bitcoin-Zahlung leicht gemacht: Sie möchten Ihr Fahrzeug mit Bitcoin bezahlen? Kein Problem!
            </p>
            <a
              href="#contact"
              className="flex items-center justify-center gap-3 px-8 py-3 border border-white text-white transition-colors duration-300 rounded-full w-fit"
            >
              Kontakt aufnehmen{" "}
              <svg
                width="13"
                height="14"
                viewBox="0 0 13 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5511 0H4.73733C454101 0 4.38215 0.16548 4.38215 0.369979C4.38215 0.574478 4.54101 0.739958 4.73733 0.739958H11.6937L0.224179 12.6873C0.08543 12.8318 0.08543 13.066 0.224179 13.2105C0.293537 13.2827 0.384438 13.3188 0.475305 13.3188C0.566173 13.3188 0.657041 13.2827 0.726432 13.2105L12.1959 1.2631V8.50928C12.1959 8.71378 12.3547 8.87925 12.5511 8.87925C12.7474 8.87925 12.9062 8.71378 12.9062 8.50928V0.369979C12.9062 0.16548 12.7473 0 12.5511 0Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
